import { SUCCESS_RESPONSE } from "../constants/api-constants"

export interface HttpGetParam {
    path: string,
    queryParams?: any
}

export interface HttpPostParam {
    path: string,
    queryParams?: any,
    body?: any
}

export interface FileUploadParams {
    path: string,
    queryParams?: any,
    body: FormData
}

export class ResponseType {
    status: number
    data: any
    description: string

    constructor({
        status = -1,
        data = null,
        description = ''
    }) {
        this.status = status
        this.data = data
        this.description = description
    }

    get isSuccess() {
        return this.status === SUCCESS_RESPONSE
    }
}